import {CircularProgress} from "@material-ui/core";
import React from "react";

const Loading = () => (
  <CircularProgress style={{marginLeft: "45%", marginTop: "40vh"}} />
);

export default Loading;
